import { useState } from "react";
import { useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { EmailArray } from "../../../data/arrayData";
import ResizeListener from "../../../utility/ResizeListener";
import secureStorage from "../../../utility/secureStorage";
import { profileDetailsService } from "../../../utility/services/profileDetailsService";
import {
  BusinessCenter,
  CustomerCenter,
  DeveloperCenter,
  FinanceCenter,
  NeokredLogo1,
  ReportCenter,
  TransactionCenter,
} from "../../resources/assetsManager";
import { LIGHT_TEXT_COLOR } from "../../resources/colorsManager";
import {
  SS_CASH_FREE,
  SS_UPI_ENABLED,
} from "../../resources/secureStorageManager";
import DashboardContainer from "./DashboardContainer";

const Dashboard = ({ profileDetails }) => {
  const navigate = useNavigate();
  const { height, width } = ResizeListener();
  const dispatch = useDispatch();
  const [isCashFreeEnabled, setIsCashFreeEnabled] = useState(false);

  const getUserSS = async () => {
    const upiSS = await secureStorage.getItem(SS_CASH_FREE);
    setIsCashFreeEnabled(upiSS);
  };
  useEffect(() => {
    getUserSS();
    if (Object.keys(profileDetails).length === 0)
      dispatch(profileDetailsService());
  }, []);
  return (
    <div
      style={{
        width: width,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: isCashFreeEnabled ? "flex-start" : "center",
          // justifyContent:
          //   width > 1100
          //     ? "flex-start"
          //     : isCashFreeEnabled
          //     ? "flex-start"
          //     : "center",
          justifyContent: "center",
          height: height * 0.6,
          width: "100%",
          maxWidth: "1260px",
          flexWrap: "wrap",
          padding: width < 1350 && "0px 30px 0px 30px",
        }}
      >
        {!isCashFreeEnabled ? (
          <>
            {/* <DashboardContainer
              title={"Business Intelligence"}
              description={
                "You can see your recent transactions and the transaction graph."
              }
              image={BusinessCenter}
              onClick={() => navigate("/business")}
            /> */}
            <DashboardContainer
              title={"Transaction Center"}
              description={
                "You can see all the transaction done by your customer and the details related to it."
              }
              image={TransactionCenter}
              onClick={() => navigate("/transaction")}
            />
            {/* <DashboardContainer
              title={"Finance Center"}
              description={
                "Your balance ledger will be shown containing credit, debit, and the closing balance."
              }
              image={FinanceCenter}
              onClick={() => navigate("/finance")}
            /> */}
            {/* {EmailArray.includes(profileDetails?.emailId) && ( */}

            {/* <DashboardContainer
              title={"Report Center"}
              description={
                "Consolidate and get insights with ease. All of your reports may be accessed from a single dashboard."
              }
              image={ReportCenter}
              onClick={() => navigate("/report")}
              imageStyle={{
                width: 32,
                height: 32,
              }}
            /> */}
            {/* )} */}
            <DashboardContainer
              title={"Developer Center"}
              description={
                "Manage your webhooks, you can also update and enable/disable."
              }
              image={DeveloperCenter}
              onClick={() => navigate("/developers")}
            />
            {/* {(profileDetails?.payOutStatus ||
          EmailArray.includes(profileDetails?.emailId)) && ( */}
            {/* <DashboardContainer
              title={"Customer Management"}
              description={
                "Create VAN for your customer and manage them. You can assign Single or bulk Virtual Account Number."
              }
              image={CustomerCenter}
              onClick={() => navigate("/customers")}
              imageStyle={
                {
                  // width: 38,
                  // height: 38,
                }
              }
            />{" "} */}
          </>
        ) : (
          <DashboardContainer
            title={"Transaction Center"}
            description={
              "You can see all the transaction done by your customer and the details related to it."
            }
            image={TransactionCenter}
            onClick={() => navigate("/transaction")}
          />
        )}
      </div>
      <div
        style={{
          width: "100%",
          height: 200,
          display: "flex",
          flexDirection: "row-reverse",
          alignItems: "center",
          padding: "0px 30px",
          paddingTop: width > 720 ? 0 : 50,
          justifyContent: width > 720 ? "right" : "center",
        }}
      >
        <img
          src={NeokredLogo1}
          style={{
            width: width * 0.15,
            height: width * 0.1,
            objectFit: "contain",
            minWidth: 100,
            minHeight: 100,
          }}
        />
        <p
          style={{
            margin: "0px 20px",
            fontSize: 14,
            color: LIGHT_TEXT_COLOR,
          }}
        >
          Powered by
        </p>

        <img
          src={profileDetails?.documentId}
          style={{
            width: width * 0.15,
            height: width * 0.1,
            objectFit: "contain",
            minWidth: 100,
            minHeight: 100,
          }}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    profileDetails: state.profileDetailsReducer.details,
  };
};
export default connect(mapStateToProps)(Dashboard);
